// Global Instructions Rule Applied!
import { DealsPaginatedResponse, fetchDealsPaginated } from '../services/dealsService.ts'
import { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setDeals } from '../../../state_manager/state_update_actions/deals/index.ts'
import { DealTarget } from '../../../state_manager/store_models/deals.ts'
import type { AppDispatch } from '../../../state_manager/store'
import { getAccessToken } from '../../../core/auth/authService'
import { store } from '../../../state_manager/store.ts'

export const useDealPipelineData = () => {
  const dispatch = useDispatch<AppDispatch>()

  // Pipeline deals
  const [pipelineDealsLoading, setPipelineDealsLoading] = useState(false)
  const pipelineDealsData = useSelector((state: any) => state.deals.pipeline.data)

  const handleFetchPipelineDeals = useCallback(async () => {
    try {
      setPipelineDealsLoading(true)
      const currentToken = getAccessToken(store.getState().auth)
      const response: DealsPaginatedResponse = await fetchDealsPaginated(1, null, currentToken)
      dispatch(setDeals({ response, target: DealTarget.PIPELINE }))
    } catch (e) {
      console.error('Error fetching pipeline deals:', e)
    } finally {
      setPipelineDealsLoading(false)
    }
  }, [dispatch])

  useEffect(() => {
    const currentToken = getAccessToken(store.getState().auth)
    if (currentToken) {
      handleFetchPipelineDeals()
    }
  }, [handleFetchPipelineDeals])

  return {
    // Pipeline deals
    pipelineDealsData,
    pipelineDealsLoading,
    handleFetchPipelineDeals
  }
}
